export const urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;

export const newLineRegex = /\n/g;

export const beginRowRegexp = /(\<br\/\>)/g;
